import {
  InputCheckbox,
  InputCheckboxProps
} from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import React, { useCallback } from "react";
import {
  useToggleRefinement,
  UseToggleRefinementProps
} from "react-instantsearch";
import { cruisesLabel } from "src/utils/cruise";
import * as styles from "./InlineToggleFilter.module.scss";

interface InlineToggleFilterProps {
  id: string;
  attribute: string;
  label: string;
  value: string | number;
  dataContentPiece?: string;
  color?: InputCheckboxProps["color"];
}

const InlineToggleFilter: React.FC<
  InlineToggleFilterProps & UseToggleRefinementProps
> = ({ value, attribute, label, id, dataContentPiece, color }) => {
  const {
    value: refineValue,
    canRefine,
    refine
  } = useToggleRefinement({ attribute, on: value, off: undefined });

  const disabled = !canRefine;
  const _onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      refine({ isRefined: !event.target.checked });
    },
    [refine]
  );

  return (
    <InputCheckbox
      checked={refineValue.isRefined}
      position="Left"
      value={value}
      id={id}
      width="full"
      disabled={disabled}
      onChange={_onChange}
      data-content-piece={dataContentPiece}
      className={styles.fixLabelAlign}
      color={color}
    >
      {label}
      <span
        className={clsx(styles.cruiseCounter, {
          [styles.cruiseCounterDisabled]: disabled
        })}
      >
        {cruisesLabel(refineValue.onFacetValue.count || 0)}
      </span>
    </InputCheckbox>
  );
};

export default InlineToggleFilter;
